import _ from "lodash";
import Event from "@/services/Event";
import Enrollment from "@/services/Enrollment";
import Auth from "@/services/Auth";
import ParseJwt from "@/helpers/ParseJwt";

import JudgeEnrollments from "@/components/Judge/Enrollments";
import JudgeRegistrationForm from "@/components/Judge/RegistrationForm";
import ParseHTTPError from "@/helpers/ParseHTTPError";

import Vue from "vue";
export default {
  name: "JudgeRegistration",

  data: function () {
    return {
      loading: false,
      loadingEvents: false,
      events: null,
      enrollments: null,

      selectedEvents: [],
      selectedJudgeArea: [],

      page: null,
    };
  },

  components: {
    JudgeRegistrationForm,
    JudgeEnrollments,
  },

  created() {
    this.fetchEvents();
  },

  methods: {
    submit() {
      let message;
      if (!this.selectedJudgeArea || !this.selectedJudgeArea.length) {
        message = "Selecione pelo menos uma área de interesse";
      }

      if (!this.selectedEvents || !this.selectedEvents.length) {
        message = "Selecione pelo menos um evento para participar";
      }

      // Validation
      if (message) {
        this.$notify.error({
          title: "Erro",
          message: message,
        });
        return;
      }

      this.save();
    },

    save() {
      const userId = _.get(ParseJwt(Auth.currentToken), "id", "");

      this.loading = true;
      const promises = [];
      for (const event of this.selectedEvents) {
        promises.push(
          Event.createEnrollment(event, userId, "user", {
            "judge.area": this.selectedJudgeArea,
          }),
        );
      }

      // Wait create all enrollments
      Promise.all(promises).then(
        () => {
          this.$notify.success({
            title: "Sucesso",
            message: "Suas inscrições foram registradas com sucesso",
          });
          this.page = "enrollments";
          this.fetchEnrollments();
        },
        (err) => {
          this.loading = false;
          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro",
            message: error,
          });
        },
      );

      this.selectedEvents = [];
    },

    fetchEnrollments() {
      this.loadingEnrollments = true;

      // if(!this.events || !this.events.length) return
      Enrollment.list().then(
        (res) => {
          this.loading = false;
          this.loadingEnrollments = false;

          this.enrollments = res.data
            .filter((e) => {
              // Set disabled if is enrollmented with it event
              if (_.find(this.events, { _id: e.event._id })) {
                const event = Object.assign(
                  {},
                  _.find(this.events, { _id: e.event._id }),
                );
                event.disabled = true;
                Vue.set(
                  this.events,
                  _.findIndex(this.events, { _id: e.event._id }),
                  event,
                );
              }

              return _.find(this.events, { _id: e.event._id }) || false;
            })
            .reverse();

          if (!this.page && this.enrollments.length >= 1) {
            this.page = "enrollments";
          } else if (!this.page) {
            this.page = "register";
          }
        },
        (err) => {
          this.loading = false;
          this.loadingEnrollments = false;
          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro",
            message: error,
          });
        },
      );
    },

    fetchEvents() {
      // this.loading = true
      this.loadingEvents = true;

      Event.list({ "event.kind": "volunteers_and_judges" }).then(
        (res) => {
          this.loadingEvents = false;
          // this.loading = false
          this.events = res.data;
          this.fetchEnrollments();
        },
        (err) => {
          this.loadingEvents = false;
          // this.loading = false
          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro",
            message: error,
          });
        },
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/JudgeRegistration/JudgeRegistration.js